<template>
  <div class="WorkOrderIssued">
    <a-card class="antd-pro-pages-dashboard-analysis-salesCard" :style="{ height: '100%' }">
      <div class="headline" slot="title">
        <div class="vertical"></div>工单发布
      </div>
      <div class="content">
        <Published-figure :data="releaseList"></Published-figure>
        <!-- <BarEchart :data="releaseList"></BarEchart> -->
      </div>
    </a-card>
  </div>
</template>

<script>
import PublishedFigure from './component/Published-figure.vue'
// import BarEchart from './../../remoteWater/workbench/component/module/BarEchart.vue'
export default {
  components: {
    // BarEchart
    PublishedFigure
  },
  data() {
    return {
      releaseList: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      // 工单发布
      this.$http.get('/pipe-network/inspection/workbench/publication').then(res => {
        
        const list = res.data
        var xdata = []
        var series = []
        list.map(item => {
          // item.time=item.time.substring(5,item.time.length)
          if (xdata.length == 0) {
            xdata = item.list
          }
          let sData = []
          item.groupPublications.map(g => {
            sData.push(g.num)
          })
          let sObj = {
            data: sData,
            type: 'bar',
            name: item.month,
            barWidth:14
          }
          series.push(sObj)
        })
        this.releaseList = {
          xdata: xdata,
          series: series,
          color: ['#3488ED', '#07C2B2'],
          grid: {
            x: '8%', // 左侧与y轴的距离
            y: '18%', // top部与x轴的距离
            x2: '2%', // 右侧与y轴的距离
            y2: '14%' // bottom部与x轴的距离
          }
        }
        console.log(this.releaseList)
      })
    }
  }
}
</script>

<style  lang="less" scoped>
.vertical {
  width: 4px;
  height: 18px;
  margin-right: 10px;
  background: #0265ff;
  border-radius: 3px;
}
.headline {
  display: flex;
  align-items: center;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #101010;
  letter-spacing: 0.63px;
  font-weight: 600;
}
.extra {
  font-family: MicrosoftYaHei;
  font-size: 12px;
  color: #a7afb5;
  letter-spacing: 0.48px;
  text-align: right;
  font-weight: 400;
}
.cardHead {
  height: 48px;
  width: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 2px;
  border-bottom: 1px solid #e8e8e8;
  .radiusTitleStatis {
    float: left;
    // width: 100px;
    // height: 21px;
    line-height: 21px;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 15px;
    color: #101010;
    letter-spacing: 0.63px;
    font-weight: 600;
  }
  .extra {
    width: 40%;
    min-width: 120px;
  }
}
/deep/ .ant-card-body {
  padding: 0;
}

.content {
  width: 100%;
  height: 200px;
}
</style>
